const masterAccounts = [
    '86ab0336-1460-4409-baf7-225ea3755307',
    
]

export default masterAccounts;